import React from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import FormError from "../../../components/forms/FormError";

const AddSerialsForm = (props) => {
  const {errors, handleSubmit, submit, submitting, serialsPending} = props;
  const label = submitting ? "Standby..." : "Add Serial Numbers";

  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <p>
          {serialsPending} units on this dispatch do not have their serial number yet. Each serial number
          goes on a line of its product that is still missing some. Once the dispatch has shipped, they
          are recorded as delivered to the client on the day it shipped.
        </p>
        <FormFieldsTable>
          <Field label="Serial Numbers" name="serialNrs" component={TextAreaInputField} rows={8}
            placeholder="One per line, or FIRST..LAST for a run" serverError={errors.serialNrs} />
        </FormFieldsTable>
      </div>
      <FormError error={errors._error} />
      <div className="buttons">
        <ActionButton label={label} onClick={submit} active={!submitting} />
        <ActionButton label="Cancel" active={!submitting} onClick={props.onCancel} />
      </div>
    </form>
  )
}

export default reduxForm({
  form: "AddSerialsToClientDispatchForm"
})(AddSerialsForm);
